module.exports = __webpack_public_path__ + "img/scene2-14.f8bf3a4c.jpg";